import { c as _c } from "react/compiler-runtime";
import { Form, type TemplateInputProps } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { useAutoDataIdentifier } from '../../../hooks/use-auto-data-identifier';
import type { CustomQuestionsFormData } from '../../../types';
import DataIdentifierField from '../data-identifier-field';
type LongTextFormProps = {
  questionIndex: number;
  autocompleteItems?: TemplateInputProps['autocompleteItems'];
};
const LongTextForm = t0 => {
  const $ = _c(42);
  const {
    questionIndex,
    autocompleteItems
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  useAutoDataIdentifier(questionIndex);
  const t1 = `questions.${questionIndex}.label`;
  let t2;
  if ($[0] !== t) {
    t2 = t(_temp);
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp2);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== autocompleteItems) {
    t4 = autocompleteItems ?? {};
    $[4] = autocompleteItems;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Form.TemplateInput name={t1} label={t2} placeholder={t3} size="compact" autocompleteItems={t4} />;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `questions.${questionIndex}.placeholder`;
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp3);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp4);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <Form.Input name={t6} label={t7} placeholder={t8} size="compact" />;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp5);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp6);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t(_temp7);
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = {
      text: t12
    };
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== questionIndex || $[28] !== t10 || $[29] !== t11 || $[30] !== t13) {
    t14 = <DataIdentifierField questionIndex={questionIndex} label={t10} placeholder={t11} tooltip={t13} />;
    $[27] = questionIndex;
    $[28] = t10;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const t15 = `questions.${questionIndex}.required`;
  let t16;
  if ($[32] !== t) {
    t16 = t(_temp8);
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = <Form.Toggle name={t15} label={t16} size="compact" />;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t14 || $[38] !== t17 || $[39] !== t5 || $[40] !== t9) {
    t18 = <div className="flex flex-col gap-6">{t5}{t9}{t14}{t17}</div>;
    $[37] = t14;
    $[38] = t17;
    $[39] = t5;
    $[40] = t9;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
export default LongTextForm;
function _temp($) {
  return $.form.label;
}
function _temp2($_0) {
  return $_0.form.labelPlaceholder;
}
function _temp3($_1) {
  return $_1.form.placeholder;
}
function _temp4($_2) {
  return $_2.form.placeholderPlaceholder;
}
function _temp5($_3) {
  return $_3.form.dataIdentifier;
}
function _temp6($_4) {
  return $_4.form.dataIdentifierPlaceholder;
}
function _temp7($_5) {
  return $_5.form.dataIdentifierTooltip;
}
function _temp8($_6) {
  return $_6.form.required;
}